import { render, staticRenderFns } from "./OutboundSummary.vue?vue&type=template&id=0814b99a&scoped=true"
import script from "./OutboundSummary.vue?vue&type=script&lang=js"
export * from "./OutboundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814b99a",
  null
  
)

export default component.exports